import { Component, OnInit, Inject } from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { ConfirmationLabTestService } from './confirmation-lab-test.service';

@Component({
  templateUrl: 'new-labtest-popup.component.html',
  providers: [ConfirmationLabTestService]
})

export class NewLabTestPopupComponent implements OnInit {
  public isAddSuccess = false;
  public labTests = [];
  public addLabTestForm: FormGroup;
  panelMaxHeight = new FormControl('mh-dropdown');
  constructor(public dialogRef: MdDialogRef<NewLabTestPopupComponent>,
    public utility: Utility,
    private formBuilder: FormBuilder,
    private confirmationLabTestService: ConfirmationLabTestService,
    @Inject(MD_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.createForm();
    this.confirmationLabTestService.getAddLabTestList(this.data.consultationId).subscribe(
      (result) => {
        if (result) {
          this.labTests = result.json();
          if (this.labTests && this.data.listCentreLabtestIds) {
            if (this.labTests.length > 0 && this.data.listCentreLabtestIds.length > 0) {
              this.data.listCentreLabtestIds.forEach(element => {
                this.labTests.splice(
                  this.labTests.findIndex(x => x.centreLabtestId === element),
                  1
                );
              });

            }
          }
        }
      }
    );
  }

  createForm() {
    this.addLabTestForm = this.formBuilder.group({
      labTest: [null, [Validators.required]]
    });
  }

  onLabTestChange(event) {
    this.addLabTestForm.value.labTest = event.value;
  }

  onCloseDialog() {
    this.dialogRef.close(this.isAddSuccess);
  }

  onSubmit() {
    if (this.addLabTestForm.dirty && this.addLabTestForm.valid) {
      this.dialogRef.close(this.addLabTestForm.value.labTest);
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/confirmation-lab-tests/new-labtest-popup.component.ts